// Money maths for one product line, shared by the product page and the checkout summary.
// The server prices an order as (unit price + chosen options) x quantity, so the number
// shown before paying must be built the same way.

export const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

// A quantity is a whole number of at least 1; anything else is treated as 1.
export const safeQuantity = (quantity) => (Number.isInteger(quantity) && quantity > 0 ? quantity : 1);

// Price of the whole line: one piece x quantity (rounded to the paisa).
export const lineSubtotal = (unitPrice, quantity) => round2(Number(unitPrice || 0) * safeQuantity(quantity));

// What is left to pay after a coupon, never below zero.
export const payableAfterDiscount = (subtotal, discount) => round2(Math.max(Number(subtotal || 0) - Number(discount || 0), 0));

// The summary the product page hands to /checkout when the buyer clicks Buy Now.
export const buildCheckoutSummary = ({ title, image, quantity, optionsLabel, unitPrice, discount = 0, couponCode }) => {
  const qty = safeQuantity(quantity);
  const subtotal = lineSubtotal(unitPrice, qty);
  const off = round2(discount || 0);
  return {
    title,
    image,
    quantity: qty,
    optionsLabel,
    unitPrice: round2(unitPrice || 0),
    subtotal,
    discount: off,
    total: payableAfterDiscount(subtotal, off),
    couponCode,
  };
};
